import { AppDialog } from '@/components/app/app-dialog.tsx';
import { TProduct, TProductColor } from '@/types/models.ts';
import { Button } from '@/components/ui/button.tsx';
import { useCuttingRequestMutation, useGetRequestCuttingQuery } from '@/app/products/api/queries.ts';
import { useEffect } from 'react';
import { useNotifications } from '@/hooks/use-notifications.ts';

type Props = {
  product: TProduct;
  color: TProductColor;
  onClose: () => void;
}

function getProductName(product: TProduct, color: TProductColor) {
  return `${product.name} - ${color.name}`;
}

export function RequestCutting({product, color, onClose} : Props) {
  const requestCutting = useCuttingRequestMutation();

  const {data: request, error} = useGetRequestCuttingQuery(color.id);

  const {showError} = useNotifications();

  useEffect(() => {
    if (error) {
      showError(error);
      onClose();
    }
  }, [error]);

  const onSendRequest = () => {
    requestCutting.mutateAsync(color.id).then(() => {
      onClose();
    });
  }
  return (
    <AppDialog title="Request A Cutting" onClose={onClose}>
      <div className="dialog-body p-4">
        <div className="flex  gap-4">
          <div>
            <p className="text-xl">Request a cutting sample for {getProductName(product, color)}</p>
            {(request && request.created_at) && (
              <p className="mt-2 text-sm text-muted-foreground">
                You have already requested a cutting for this color on {new Date(request.created_at).toLocaleDateString()}.
              </p>
            )}
          </div>
          <div className="w-32 h-32 overflow-hidden flex">
            <img src={color.img_thumb} alt={color.name} className="object-cover rounded min-w-full" />
          </div>
        </div>
      </div>
      <div className="dialog-footer">
        <Button onClick={onSendRequest}>Send Request</Button>
      </div>
    </AppDialog>
  );
}